import * as React from 'react'

function PasswordAccessIcon(props) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3510_4680)">
        <path
          d="M10.4657 10.3133C10.5121 10.3599 10.5488 10.4151 10.5739 10.4759C10.5989 10.5367 10.6117 10.6018 10.6116 10.6676C10.6115 10.7333 10.5984 10.7984 10.5731 10.8591C10.5479 10.9198 10.5109 10.9749 10.4643 11.0213C10.4177 11.0677 10.3625 11.1045 10.3017 11.1295C10.2409 11.1546 10.1758 11.1674 10.11 11.1673C10.0443 11.1672 9.97922 11.1541 9.91853 11.1288C9.85784 11.1035 9.80272 11.0666 9.75632 11.02C9.66261 10.9259 9.6101 10.7985 9.61035 10.6657C9.6106 10.5329 9.66359 10.4057 9.75765 10.312C9.85171 10.2183 9.97915 10.1658 10.1119 10.166C10.2447 10.1663 10.3719 10.2193 10.4657 10.3133"
          stroke="#1F2D27"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3533 10.3133C16.3997 10.3599 16.4365 10.4151 16.4616 10.4759C16.4866 10.5367 16.4994 10.6018 16.4993 10.6676C16.4992 10.7333 16.4861 10.7984 16.4608 10.8591C16.4356 10.9198 16.3986 10.9749 16.352 11.0213C16.3054 11.0677 16.2502 11.1045 16.1894 11.1295C16.1286 11.1546 16.0635 11.1674 15.9977 11.1673C15.932 11.1672 15.8669 11.1541 15.8062 11.1288C15.7455 11.1035 15.6904 11.0666 15.644 11.02C15.5503 10.9259 15.4978 10.7985 15.498 10.6657C15.4983 10.5329 15.5513 10.4057 15.6453 10.312C15.7394 10.2183 15.8668 10.1658 15.9996 10.166C16.1324 10.1663 16.2596 10.2193 16.3533 10.3133"
          stroke="#1F2D27"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.243 10.3133C22.3367 10.4074 22.3892 10.5348 22.389 10.6676C22.3887 10.8004 22.3357 10.9276 22.2417 11.0213C22.1476 11.115 22.0202 11.1675 21.8874 11.1673C21.7546 11.167 21.6274 11.114 21.5337 11.02C21.4873 10.9734 21.4505 10.9181 21.4254 10.8574C21.4004 10.7966 21.3876 10.7314 21.3877 10.6657C21.3878 10.6 21.4009 10.5349 21.4262 10.4742C21.4514 10.4135 21.4884 10.3584 21.535 10.312C21.5816 10.2656 21.6368 10.2288 21.6976 10.2038C21.7584 10.1787 21.8235 10.1659 21.8893 10.166C21.955 10.1661 22.0201 10.1792 22.0808 10.2045C22.1415 10.2298 22.1966 10.2667 22.243 10.3133"
          stroke="#1F2D27"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6667 17.3333H6.66667C5.95942 17.3333 5.28115 17.0524 4.78105 16.5523C4.28095 16.0522 4 15.3739 4 14.6667L4 6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4L25.3333 4C26.0406 4 26.7189 4.28095 27.219 4.78105C27.719 5.28115 28 5.95942 28 6.66667V10.6667"
          stroke="#1F2D27"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8577 20.9274V18.6154C25.8577 17.9212 25.582 17.2555 25.0911 16.7646C24.6003 16.2738 23.9345 15.998 23.2404 15.998C22.5462 15.998 21.8805 16.2738 21.3896 16.7646C20.8988 17.2555 20.623 17.9212 20.623 18.6154V20.9274"
          stroke="#1F2D27"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.667 20.9316H20.0003C19.6467 20.9316 19.3076 21.0721 19.0575 21.3222C18.8075 21.5722 18.667 21.9114 18.667 22.265V26.6676C18.667 27.0213 18.8075 27.3604 19.0575 27.6105C19.3076 27.8605 19.6467 28.001 20.0003 28.001H26.667C27.0206 28.001 27.3598 27.8605 27.6098 27.6105C27.8599 27.3604 28.0003 27.0213 28.0003 26.6676V22.265C28.0003 21.9114 27.8599 21.5722 27.6098 21.3222C27.3598 21.0721 27.0206 20.9316 26.667 20.9316Z"
          stroke="#1F2D27"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3510_4680">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export { PasswordAccessIcon }
